var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubscriptionMore28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#subscription_more_28)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 20.857a6.857 6.857 0 1 0 0-13.714 6.857 6.857 0 0 0 0 13.714Zm3.143-5.714a1.143 1.143 0 1 0 0-2.286 1.143 1.143 0 0 0 0 2.286Zm-2-1.143a1.143 1.143 0 1 1-2.286 0 1.143 1.143 0 0 1 2.286 0Zm-4.286 1.143a1.143 1.143 0 1 0 0-2.286 1.143 1.143 0 0 0 0 2.286Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "subscription_more_28",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#619DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505DE6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionMore28);
export default __webpack_public_path__ + "static/media/subscription_more_28.903a7233.svg";
export { ForwardRef as ReactComponent };